// src/components/HospitalError.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from "@mui/material";

const HospitalError: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', bgcolor: '#f5f5f5', p: 2 }}>
      <Paper elevation={3} sx={{ p: 5, textAlign: 'center', borderRadius: 2, maxWidth: 400 }}>
        <Typography variant="h5" color="error" gutterBottom fontWeight="bold">
          병원 정보를 찾을 수 없습니다
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
          잘못된 경로로 접근하셨거나<br />등록되지 않은 병원입니다.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => navigate('/')}>
          메인으로 이동하기
        </Button>
      </Paper>
    </Box>
  );
};

export default HospitalError;